import { ContentId } from 'src/utils/constants/contentId';

import { PurchaseOrderInput } from './steps/PurchaseOrderInput/PurchaseOrderInput';
import { ReviewPurchases } from './steps/ReviewPurchases';
import { SearchEvent } from './steps/SearchEvent';

export const Steps = {
  SearchEvent: 'SearchEvent',
  PurchaseInput: 'PurchaseInput',
  Review: 'Review',
} as const;

export const TicketGroupInputSteps: (keyof typeof Steps)[] = [
  Steps.SearchEvent,
  Steps.PurchaseInput,
  Steps.Review,
];

export const MultiplePurchaseFlowConfig = {
  [Steps.SearchEvent]: {
    title: ContentId.SearchEvent,
    component: SearchEvent,
    footerActions: {
      onPreviousLabel: ContentId.Close,
      onNextLabel: ContentId.Next,
      prevStep: Steps.PurchaseInput,
      nextStep: Steps.PurchaseInput,
    },
  },
  [Steps.PurchaseInput]: {
    title: ContentId.AddPurchase,
    component: PurchaseOrderInput,
    nextStepValidation: true,
    footerActions: {
      onPreviousLabel: ContentId.Prev,
      onNextLabel: ContentId.Save,
      prevStep: Steps.SearchEvent,
      nextStep: Steps.Review,
    },
  },
  [Steps.Review]: {
    title: ContentId.Preview,
    component: ReviewPurchases,
    footerActions: {
      onPreviousLabel: ContentId.Prev,
      onNextLabel: ContentId.Save,
      prevStep: Steps.PurchaseInput,
      nextStep: Steps.Review,
    },
  },
};
